import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=1dde5b39&"
import script from "./Treatment.vue?vue&type=script&lang=js&"
export * from "./Treatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports